import React from "react"
//import { Link } from "gatsby"
import {graphql, StaticQuery, Link} from 'gatsby'
//import './Teams.css';

const HostcupNav = () => (
    <StaticQuery query={graphql`
      {
        allWordpressWpHostcup {
          edges {
            node {
              title
              slug
              content
              
            }
          }
        }
      }
    `} render={props => (

        <ul class="nav justify-content-center p-4 bg-light">
        {props.allWordpressWpHostcup.edges.map(post => (

            <li key={post.node.id} className="nav-item">
                
                <Link to={`hostcup/${post.node.slug}`} className="nav-link" activeClassName="active">{post.node.title}</Link>
            </li>

        ))}
      </ul>

    )} />
)

export default HostcupNav;